import React, {useContext} from "react";
import {Grid, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import {LanguageContext} from "../../context/LanguageContext";
import PropTypes from "prop-types";
import {makeStyles} from "@mui/styles";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from "@mui/material/IconButton";
import {Link} from "react-router-dom";
import {getStatusIcon} from "../../utils/commonFunctions";

const useStyles = makeStyles(theme => ({
  duration: {
    fontSize: 33,
    float: "left",
    marginRight: 5
  },
  rightGrid: {
    [theme.breakpoints.up('lg')]: {
      textAlign: "right"
    }
  },
  avatar: {
    backgroundColor: "white",
    color: theme.palette.secondary.main,
    borderStyle: "solid",
    borderWidth: 2,
    width: 60,
    height: 60,
    fontSize: 25
  },
  boldRow: {
    fontWeight: "bold"
  },
  divider: {
    background: theme.palette.secondary.main
  },
  boldText: {
    fontWeight: "bold"
  }
}));

const ServiceGrid = ({data}) => {
  const classes = useStyles();
  const languageContext = useContext(LanguageContext);

  return (
    <Paper style={{padding: 15}}>
      <Grid container alignItems="center" justifyContent="space-around" spacing={2}>
        <Grid item container xs={10} md={11} alignItems="center" justifyContent="space-around">
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="subtitle1" className={classes.boldText}>{data.serviceCatalogX0Description}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <Typography variant="subtitle1">{languageContext.dictionary.serviceId}</Typography>
            <Typography variant="subtitle1" className={classes.boldText}>{data.linkCode}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <Typography variant="subtitle1">{languageContext.dictionary.contractNumber}</Typography>
            <Typography variant="subtitle1" className={classes.boldText}>{data.contractId}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={2} style={{display: "flex"}}>
            {getStatusIcon(data.serviceStatusDescription)}
            <Typography variant="subtitle1" sx={{paddingLeft: 1}} className={classes.boldText}>{data.serviceStatusDescription}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={2} md={1}>
          <Link to={`/serviceDetails/${data.poId}`} style={{textDecoration: 'none'}}>
            <IconButton color="secondary">
              <ChevronRightIcon/>
            </IconButton>
          </Link>
        </Grid>
      </Grid>
    </Paper>
  );
};

ServiceGrid.propTypes = {
  data: PropTypes.object
};

export default ServiceGrid;